module.exports = __webpack_public_path__ + "static/media/63da833-konnektive-logo-2.d83840d3.png";